import React from "react";
import { Button, Form, Card, Alert, Spinner } from "react-bootstrap";
import { store } from "../../reducer/Store";
import Utils from "../../services/Utils";
import { ToastContainer } from "react-toastify";
import ApiService from "../../services/ApiService";
const RapportPdf = () => {

  const { state } = React.useContext(store);

  const [pdf, setPdf] = React.useState({
    challenge: false,
    operation: false,
  });
  const [loader, setLoader] = React.useState(false);
  const handleClose = () => {
    setPdf({
      challenge: false,
      operation: false
    });
  };

  /**
   * La fonction handleSubmitExportPdfClient est utilisée pour soumettre le formulaire et exporter le rapport PDF du client.
   * Elle prend en paramètre e, l'événement de soumission du formulaire.
   * Active le chargement (loader) pour afficher une indication de progression.
   * Empêche le comportement par défaut du formulaire.
   * Prépare les données à envoyer dans la requête en rassemblant les informations nécessaires telles que l'identifiant du client, l'identifiant de l'année, l'identifiant de la marque, 
   * le nom de l'année, et les informations pour l'affichage du rapport (opération et défi).
   * Effectue une requête à l'API pour récupérer le fichier PDF en utilisant les données préparées.
   * En cas de succès de la requête, génère un lien de téléchargement pour le fichier PDF et déclenche le téléchargement.
   * Affiche une notification de succès pour informer l'utilisateur que le rapport PDF a été téléchargé avec succès.
   * En cas d'erreur lors de la requête, affiche une notification d'erreur et affiche le message d'erreur dans la console.
   * @param {*} e 
   */
  const handleSubmitExportPdfClient = async (e) => {
    setLoader(true)
    e.preventDefault();
    const data = {
      customer_id: parseInt(state.dataCustomer.id),
      year_id: parseInt(state.currentYear.value),
      brand_id: parseInt(
        state.currentBrands.length > 0 ? state.currentBrands[0].value : ""
      ),
      year_name: parseInt(state.currentYear.label),
      display_operation: pdf.operation,
      display_challenge: pdf.challenge,
    };

    ApiService.requestBlobFile(data, 'export-pdf', "post")
      .then((response) => {
        handleClose()
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Rapporttrade_${state.dataCustomer.id +
          "_" +
          state.currentBrands[0].label +
          "_" +
          state.currentYear.label
          }.pdf`
        );
        setLoader(false)
        handleClose()
        document.body.appendChild(link);
        link.click();
        Utils.notifySuccess("Rapport Pdf téléchargé");
      })
      .catch((error) => {
        setLoader(false)
        handleClose()
        Utils.notifyError("du téléchargement du Rapport Pdf");
        console.log(error);
      });
  };
  const handlePdfToExportChange = (field) => {
    return (e) => {
      setPdf((prev) => ({
        ...prev,
        [field]: e.target.checked,
      }));
    };
  };
  return (
    <>
      <h1>
        Rapport client
      </h1>
      {((state.currentBrands.length === 0 || state.currentBrands.length > 1) &&
        (state.dataSelectedClient &&
          state.dataSelectedClient.id)) || (state.totalNumberOfCustomerChallenges === 0 && state.totalNumberOfCustomerOperations === 0) ? "" : !loader ?
        <Card className="w-100" >
          <Card.Title>
            {" "}
            <h2> Générer le rapport</h2>{" "}
          </Card.Title>
          <Form onSubmit={(e) => handleSubmitExportPdfClient(e)}>
            <Card.Body>
              <div className="row">
                <div className="mb-3">
                  <Form.Group
                    className="d-flex flex-row mb-3"
                    controlId="new-operation"
                  >
                    <Form.Label className="col">Afficher les opérations :</Form.Label>
                    <span className="mr-5">Non &emsp; </span>
                    <Form.Check
                      type="switch"
                      value={pdf.operation}
                      onChange={handlePdfToExportChange("operation")}
                    />
                    <span>&emsp; Oui</span>
                  </Form.Group>
                </div>
                <div>
                  <Form.Group
                    className="d-flex flex-row "
                    controlId="new-operation"
                  >
                    <Form.Label className="col">
                      Afficher les challenges :
                    </Form.Label>
                    <span>Non &emsp; </span>
                    <Form.Check
                      type="switch"
                      value={pdf.challenge}
                      onChange={handlePdfToExportChange("challenge")}
                    />
                    <span>&emsp; Oui</span>
                  </Form.Group>
                </div>
              </div>
            </Card.Body>
            <Button variant="success" type="submit" className="mx-2" disabled={pdf.challenge === false && pdf.operation === false}>
              Générer le Pdf
            </Button>
          </Form>
        </Card> :
        <div className="text-center pt-5">
          <Spinner
            animation={loader ? "border" : false}
            role="status"
          ></Spinner>
        </div>
      }

      <ToastContainer />
      {(state.totalNumberOfCustomerChallenges === 0 && state.totalNumberOfCustomerOperations === 0) && (
        <Card className="text-center my-3">
          <Card.Body>
            <Alert variant="danger" className="m-0">
              Aucune opération et challenge pour ce client
            </Alert>
          </Card.Body>
        </Card>
      )


      }
      {(state.currentBrands.length === 0 || state.currentBrands.length > 1) &&
        state.dataSelectedClient &&
        state.dataSelectedClient.id ? (
        <Card className="text-center">
          <Card.Body>
            <Alert variant="danger" className="m-0">
              Veuillez sélectionner une seule marque pour exporter le rapport.
            </Alert>
          </Card.Body>
        </Card>
      ) : state.dataSelectedClient && state.dataSelectedClient.id ? (
        ""
      ) : (
        <Card className="text-center">
          <Card.Body>
            <Alert variant="danger" className="m-0">
              Veuillez sélectionner un client.
            </Alert>
          </Card.Body>
        </Card>
      )}


    </>
  );
};

export default RapportPdf;
